import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { Observable, map, of } from 'rxjs';

import { GlobalEvouchersRoutes } from '@hdms/shared/common-types';
import { FeatureToggleService, PreloadType, PreloaderService, RedirectService } from '@hdms/shared/util-core';

import { OauthService, OauthUserType } from '../oauth';
import { FT_NGC_EVOUCHER } from '../toggles';
import { UserContextService } from '../user/user-context.service';

export const canActivateEvoucherLogin: CanActivateFn = () => inject(EvoucherLoginRedirectGuard).canActivate();

@Injectable({
  providedIn: 'root'
})
export class EvoucherLoginRedirectGuard {
  constructor(
    private readonly oauthService: OauthService,
    private readonly userContext: UserContextService,
    private readonly router: Router,
    private readonly preloader: PreloaderService,
    private readonly redirect: RedirectService,
    private readonly toggleSrv: FeatureToggleService
  ) {}
  canActivate(): Observable<UrlTree | boolean> {
    if (this.toggleSrv.getToggleById(FT_NGC_EVOUCHER)) {
      return this.userContext.update$().pipe(
        map(_ => {
          if (!this.userContext.isEVoucherBackofficeUser) {
            this.preloader.startLoading(PreloadType.MANUAL);
            this.oauthService.getLoginUrl$(OauthUserType.EVOUCHER).subscribe(url => {
              this.redirect.redirectTo(url, true);
            });
            return true;
          }

          return this.router.createUrlTree([GlobalEvouchersRoutes.BASE]);
        })
      );
    }
    return of(true);
  }
}
